import { useState } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger, badgeVariants, cn } from '@shigo-ui/ui';

/**
 * Network name with the user's roles on it. Opens on hover and focus, and also on tap:
 * Radix tooltips ignore touch and close on click, so mobile could not read the roles.
 */
export function NetworkBadge({ name, roles }: { name: string; roles: string }) {
  const [open, setOpen] = useState(false);
  return (
    // delayDuration here: DashboardDataTable wraps its rows in its own TooltipProvider.
    <Tooltip open={open} onOpenChange={setOpen} delayDuration={0}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className={cn(
            badgeVariants({ variant: 'neutral' }),
            // my-0! overrides the table's in-cell `[&_button]:-my-2`, which overlaps wrapped badges.
            'my-0! cursor-default rounded-full px-2 py-0.5 outline-none focus:ring-0 focus:ring-offset-0',
          )}
          onClick={(event) => {
            // Keeps Radix from closing the tooltip on click.
            event.preventDefault();
            setOpen(true);
          }}
        >
          {name}
        </button>
      </TooltipTrigger>
      <TooltipContent>{roles}</TooltipContent>
    </Tooltip>
  );
}
